const systemHelper = {
  setUserAgent(window, userAgent) {
    if (window.navigator.userAgent !== userAgent) {
      const userAgentProp = {
        get() {
          return userAgent;
        },
      };

      try {
        Object.defineProperty(window.navigator, 'userAgent', userAgentProp);
      } catch (e) {
        window.navigator = Object.create(navigator, {
          userAgent: userAgentProp,
        });
      }
    }
  },


  /**
   * Returns a the current iOS version
   * @param {Boolean} includeMinor - Whether to include the minor version
   * @returns {Number} The current iOS version (-1 means no version was found)
   */
  iOSVersion(includeMinor) {
    const match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);

    if (!match) {
      return -1;
    }

    const version = [
      parseInt(match[1], 10),
      parseInt(match[2], 10),
      parseInt(match[3] || 0, 10),
    ];

    if (!includeMinor) {
      return version[0];
    }

    return parseFloat(version.join('.'));
  },


  /**
   * Returns a the current Android version
   * @returns {Number} The current Android version (-1 means no version was found)
   */
  androidVersion() {
    const ua = navigator.userAgent.toLowerCase();
    const match = ua.match(/android\s([0-9\.]*)/);

    return match ? match[1] : -1;
  },


  /**
   * Returns true if the browser is Firefox
   * @returns {Boolean} if the browser is Firefox
   */
  isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  },


  /**
   * Returns true if the browser is IE or Edge
   * @returns {Boolean} if the browser is IE or Edge
   */
  isIEOrEdge() {
    return (document.documentMode || /Edge/.test(navigator.userAgent));
  },
};

export default systemHelper;



/** WEBPACK FOOTER **
 ** ./assets/js/src/helpers/system.js
 **/